import CloseIcon from '@mui/icons-material/Close'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'

export default function BooleanRender(params: GridRenderCellParams) {
  const value = params.value as boolean | undefined | null

  return !!value ? (
    <CheckCircleIcon sx={{ fontSize: '1.5rem' }} color="primary" />
  ) : (
    <CloseIcon sx={{ fontSize: '1.5rem' }} color="disabled" />
  )
}
